import { prePageCall } from '@marriott/mi-headless-utils';
import { GetServerSideProps } from 'next';

//This returns a component which can be rendered in any product specific [[page.tsx]]
//to return the page template(Head, main, sections) along with the required react Components mentioned in model.json and
// load the CSS and JS libs required by static components from AEM.
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { Layout, respGridUtil } from '@marriott/mi-headless-utils';
import { envVarKeys } from '../../_constants/envVarKeys';

export default function CardLandingPage({ model, pagePath, isAuthorMode, query }) {
  const {
    metaNames,
    metaProperties,
    title,
    staticComponentClientLibsCSS,
    staticComponentClientLibsJS,
    gridCss,
    canonical,
    hreflangList,
  } = model;
  const respGridModel = respGridUtil(model?.cqItems?.root?.[':items']?.responsivegrid);
  const cardName = query?.cardName;
  const showAlternateTheme =
    cardName?.includes('canada-credit-cards') ||
    cardName?.includes('uae-credit-cards') ||
    cardName?.includes('india-credit-cards');
  return (
    <Layout
      metaNames={metaNames}
      metaProps={metaProperties}
      title={title}
      staticComponentClientLibsCSS={staticComponentClientLibsCSS}
      staticComponentClientLibsJS={staticComponentClientLibsJS}
      isAuthorMode={isAuthorMode}
      gridCss={gridCss}
      canonical={canonical}
      hreflangList={hreflangList}
    >
      <section>
        <div className={showAlternateTheme ? 'alternate' : ''}>
          <ResponsiveGrid
            key={pagePath}
            {...respGridModel}
            model={respGridModel}
            pagePath={pagePath}
            itemPath="root/responsivegrid"
          />
        </div>
      </section>
    </Layout>
  );
}

const cobrandSpecificData = async () => {
  return { operationSignatures: [], nextPublicEnvKeys: [...Object.keys(envVarKeys)] };
};

//SSR Render
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps: GetServerSideProps<any> = prePageCall(cobrandSpecificData);
